<template>
    <div>
        <button type="button" class="submit-btn text-center">
            <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'Blackbtn',

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.submit-btn{
    color: white;
    background-color: #000;
    padding: 10px 40px;
    border: 1px;
}
</style>
